<template>
    <div>
        <div class="slider_box" v-if="imgList.length!==0">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for="(item,index) in imgList" :key="index">
                    <router-link :to="item.linkUrl" v-if="item.linkUrl!=undefined" target="_blank"><img :src="item.mobileUrl" alt=""></router-link>
                </van-swipe-item>
            </van-swipe>
        </div>
        
        <div class="cyfw">
            <div class="title">常用服务</div>
            <div class="service_list">
                <div class="item" v-for="item in dataPersonal" :key="item.id">
                    <a :href="item.url" v-if="item.url!=undefined" target="_blank">
                        <div class="pic"><img :src="item.icon" alt=""></div>
                        <div class="tit">{{item.title}}</div>
                    </a>
                </div>
            </div>
        </div>
       

        <div class="bszn">
            <div class="title">
                <h2>办事指南</h2>
                <router-link :to="{name:'M_ServiceGuide'}" class="more">更多&gt;&gt;</router-link>
            </div>
            <van-collapse v-model="activeName" accordion class="accordion_list">
                <van-collapse-item title="军转干部" name="1" v-if="dataJzgb.length>0">
                    <ul>
                        <li v-for="(item,index) in dataJzgb" :key="index">
                            <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">{{item.title}}</a>
                            <router-link v-else :to="'/m/detail/'+item.id" target="_blank">{{item.title}}</router-link>
                            <van-icon name="arrow" />
                        </li>
                    </ul>
                </van-collapse-item>
                <van-collapse-item title="随军家属" name="2" v-if="dataSjjs.length>0">
                    <ul>
                        <li v-for="(item,index) in dataSjjs" :key="index">
                            <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">{{item.title}}</a>
                            <router-link v-else :to="'/m/detail/'+item.id" target="_blank">{{item.title}}</router-link>
                            <van-icon name="arrow" />
                        </li>
                    </ul>
                </van-collapse-item>
                <van-collapse-item title="逐月领取退役金" name="3" v-if="dataZylq.length>0">
                    <ul>
                        <li v-for="(item,index) in dataZylq" :key="index">
                            <router-link :to="item.linkUrl ? item.linkUrl : '/m/detail/'+item.id" v-if="item.id!=undefined" target="_blank">{{item.title}}</router-link><van-icon name="arrow" />
                        </li>
                    </ul>
                </van-collapse-item>
                <van-collapse-item title="业务办理指南" name="4" v-if="dataYwbl.length>0">
                    <ul>
                        <li v-for="(item,index) in dataYwbl" :key="index">
                            <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">{{item.title}}</a>
                            <router-link v-else :to="'/m/detail/'+item.id" target="_blank">{{item.title}}</router-link>
                            <van-icon name="arrow" />
                        </li>
                    </ul>
                </van-collapse-item>
            </van-collapse>
        </div>

        <div class="ggtz">
            <van-tabs v-model="active">
                <van-tab title="公告通知">
                    <ul>
                        <li v-for="(item,index) in dataTzgg" :key="index">
                            <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">{{item.title}}</a>
                            <router-link v-else :to="'/m/detail/'+item.id" target="_blank">{{item.title}}</router-link>
                        </li>
                    </ul>
                    <router-link :to="{name:'M_Notice'}" class="more">更多&gt;&gt;</router-link>
                </van-tab>
                <!-- <van-tab title="公示信息">
                    <ul>
                        <li v-for="(item,index) in dataGsxx" :key="index">
                            <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">{{item.title}}</a>
                            <router-link v-else :to="'/m/detail/'+item.id" target="_blank">{{item.title}}</router-link>
                        </li>
                    </ul>
                    <router-link :to="{name:'M_Announce'}" class="more">更多&gt;&gt;</router-link>
                </van-tab> -->
                <van-tab title="政策法规">
                    <ul>
                        <li v-for="(item,index) in dataZcfg" :key="index">
                            <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">{{item.title}}</a>
                            <router-link v-else :to="'/m/detail/'+item.id" target="_blank">{{item.title}}</router-link>
                        </li>
                    </ul>
                    <router-link :to="{name:'M_Policies'}" class="more">更多&gt;&gt;</router-link>
                </van-tab>
            </van-tabs>
        </div>

        <div class="ggtz">
            <van-tabs v-model="activeTz">
                <van-tab title="培训通知">
                    <ul>
                        <li v-for="(item,index) in dataPxtz" :key="index">
                            <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank" v-html="item.title"></a>
                            <router-link v-else :to="'/m/veteranDetail/'+item.id" v-html="item.title" target="_blank"></router-link>
                        </li>
                    </ul>
                    <router-link :to="{name:'M_TrainingNotice'}" class="more">更多&gt;&gt;</router-link>
                </van-tab>
                <van-tab title="课程信息">
                    <ul>
                        <li v-for="(item,index) in dataKcxx" :key="index">
                            <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">{{item.title}}</a>
                            <router-link v-else :to="'/m/detail/'+item.id" target="_blank">{{item.title}}</router-link>
                        </li>
                    </ul>
                    <router-link :to="{name:'M_Course'}" class="more">更多&gt;&gt;</router-link>
                </van-tab>
                <van-tab title="意见征集">
                    <ul>
                        <li v-for="(item,index) in dataWjdc" :key="index">
                            <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank" v-html="item.title"></a>
                            <router-link v-else :to="'/m/investigationDetail/'+item.key" v-html="item.title" target="_blank"></router-link>
                            <span class="date">{{item.date}}</span>
                        </li>
                    </ul>
                    <router-link :to="{name:'M_Investigation'}" class="more">更多&gt;&gt;</router-link>
                </van-tab>
            </van-tabs>
        </div>

        <div class="ggtz">
            <van-tabs v-model="activeCj">
                <van-tab title="常见问题">
                    <ul>
                        <li v-for="(item,index) in dataCjwt" :key="index">
                            <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">{{item.title}}</a>
                            <router-link v-else :to="'/m/detail/'+item.id" target="_blank">{{item.title}}</router-link>
                            <span class="date">{{item.date}}</span>
                        </li>
                    </ul>
                    <router-link :to="{name:'M_CommonProblem'}" class="more">更多&gt;&gt;</router-link>
                </van-tab>
                <van-tab title="来信选登">
                    <ul>
                        <li v-for="(item,index) in dataLxxd" :key="index">
                            <router-link :to="'/M/ConsultDetail/'+item.id" v-if="item.id!=undefined" target="_blank">{{item.title}}</router-link><span class="date">{{item.date}}</span>
                        </li>
                    </ul>
                    <router-link :to="{name:'M_Interaction'}" class="more">更多&gt;&gt;</router-link>
                </van-tab>
            </van-tabs>
        </div>

        <div class="rwfc">
            <div class="title">人物风采</div>
            <div v-for="(item,index) in dataRwfc" :key="index" class="rwfcItem">
                <a :href="item.linkUrl" target="_blank" v-if="item.linkUrl">
                    <div class="pic"><img :src="item.imgSrc[0].url" :alt="item.title"></div>
                    <div class="txtCon">
                        <div class="tit">{{item.title}}</div>
                        <div class="desc">{{item.desc}}</div>
                    </div>
                </a>
                <router-link :to="'/m/detail/'+item.id" target="_blank" v-else>
                    <div class="pic"><img :src="item.imgSrc[0].url" :alt="item.title"></div>
                    <div class="txtCon">
                        <div class="tit">{{item.title}}</div>
                        <div class="desc">{{item.desc}}</div>
                    </div>
                </router-link>
            </div>
            
            <router-link :to="{name:'M_Character'}" class="more">更多&gt;&gt;</router-link>
        </div>

        <bottom-menu></bottom-menu>
    </div>
</template>

<script>
import { getBanner, getLists, getWjdcLists,getServicesMenu, getVeteranPage,getConsultLists } from '@/service/api.js'
import { dateFormat } from '@/utils/util.js'
import BottomMenu from '@/components/mobile/BottomMenu.vue'
export default {
    components: { BottomMenu },
    data() {
        return {
            activeName: '1',
            activeTz:0,
            active:0,
            activeCj:0,
            imgList: [],
            dataJzgb:[],
            dataSjjs:[],
            dataZylq:[],
            dataYwbl:[],
            dataTzgg:[],
            dataGsxx:[],
            dataZcfg:[],
            dataPxtz:[],
            dataKcxx:[],
            dataWjdc:[],
            dataCjwt:[],
            dataRwfc:[],
            dataPersonal:[],
            dataLxxd:[]
        }
    },
    methods: {
        getBsznList(options,list) {
            getLists(options).then((data) => {
                if (data.code !== 0) {
                    this.$toast(data.msg)
                }else if(data.code === 0 && data.data.length){
                    let forLength = 0;
                    data.data.length<6 ? forLength = data.data.length :forLength=6
                    for (let i = 0; i < forLength; i++) {
                        let temp = {};
                        temp.id = data.data[i].id;
                        temp.title = data.data[i].title;
                        temp.date = dateFormat(data.data[i].pushTime,'Y-M-D')
                        temp.linkUrl = data.data[i].linkUrl
                        list.push(temp)
                    }
                }else{
                    console.log('无数据');
                }
            });
        },
        transformData(resData,targetData){
            if(resData.length){
                for (let i = 0; i < resData.length; i++) {
                    let temp = {};
                    temp.title = resData[i].title;
                    temp.id = resData[i].trainId;
                    temp.date = dateFormat(resData[i].pushTime,'Y-M-D');
                    targetData.push(temp)
                }
            }
        },
    },
    mounted () {
        //获取个人服务和企业服务菜单
        getServicesMenu().then((data) => {
            console.log('menu:',data);
            if (data.code!==0) {
                this.$toast(data.msg)
            }else{
                // 个人服务菜单
                if(data.data.personal.length){
                    for (let i = 0; i < data.data.personal.length; i++) {
                        if (data.data.personal[i].name === '成绩查询') {
                            continue
                        }
                        let temp = {};
                        temp.title = data.data.personal[i].name;
                        temp.id = data.data.personal[i].id;
                        temp.icon = data.data.personal[i].mobileIcon;
                        if(data.data.personal[i].openUrl){
                            temp.url = data.data.personal[i].openUrl
                        }
                        this.dataPersonal.push(temp)
                    }
                    console.log('this.dataPersonal',this.dataPersonal);
                }
            }
        });

        // 培训信息
        getVeteranPage({pageNo:1, pageSize:10, type:0, status:1}).then(data=>{
            console.log('培训信息:',data);
            if (data.code !==0) {
                this.$toast(data.msg)
            }else{
                let forLength = data.data.list.length;
                if(forLength){
                    if (forLength>6) {
                        forLength=6
                    }
                    for (let i = 0; i < forLength; i++) {
                        let temp = {};
                        if (data.data.list[i].allow===1) {
                            temp.title = `<span class="redTxt">在线报名</span>${data.data.list[i].title}`
                        }else{
                            temp.title = data.data.list[i].title
                        }
                        temp.id = data.data.list[i].trainId;
                        temp.date = dateFormat(data.data.list[i].pushTime,'Y-M-D');
                        temp.linkUrl = data.data.list[i].linkUrl
                        this.dataPxtz.push(temp)
                    }
                }
            }
        });

        // 来信选登
        getConsultLists({pageNo:1, pageSize:10, type:0, status:0}).then(data=>{
            console.log('来信选登:',data);
            if (data.code !==0) {
                this.$toast(data.msg)
            }else{
                let forLength = data.data.list.length;
                if(forLength){
                    if (forLength>6) {
                        forLength=6
                    }
                    for (let i = 0; i < forLength; i++) {
                        let temp = {};
                        temp.title = data.data.list[i].title;
                        temp.id = data.data.list[i].consultAskId;
                        temp.date = dateFormat(data.data.list[i].questionTime,'Y-M-D');
                        this.dataLxxd.push(temp)
                    }
                }
            }
        });

       
        getBanner().then((data) => {
            console.log('banner',data);
            if (data.code !== 0) {
                this.$toast(data.msg)
            }else{
                this.imgList = data.data
            }
        });
        
        // 军转干部
        this.getBsznList({contentType:9},this.dataJzgb)
        // 随军家属
        this.getBsznList({contentType:8},this.dataSjjs)
        // 逐月领取退役金
        this.getBsznList({contentType:10},this.dataZylq)
        // 业务办理指南
        this.getBsznList({contentType:11},this.dataYwbl)
        // 通知公告
        this.getBsznList({type:1},this.dataTzgg)
        // 公示信息
        this.getBsznList({type:2},this.dataGsxx)
        // 政策法规
        this.getBsznList({type:4},this.dataZcfg)
        // 课程信息
        this.getBsznList({type:5},this.dataKcxx)
        // 常见问题
        this.getBsznList({type:6},this.dataCjwt)
        // 问卷调查
        getWjdcLists({}).then(data=>{
            console.log('问卷调查',data);
            if (data.code !== 0) {
                this.$toast(data.msg)
            }else if(data.code === 0 && data.data.list.length){
                let forLength = 0;
                data.data.list.length<6 ? forLength = data.data.list.length :forLength=6
                for (let i = 0; i < forLength; i++) {
                    let temp = {};
                    if (data.data.list[i].status===2) {
                        temp.title = `<span class="redTxt">在线填写</span>${data.data.list[i].name}`
                    }else{
                        temp.title = data.data.list[i].name
                    }
                    temp.id = data.data.list[i].id;
                    temp.key = data.data.list[i].key;
                    temp.date = dateFormat(data.data.list[i].createTime,'Y-M-D')
                    this.dataWjdc.push(temp)
                }
            }else{
                console.log('无数据');
            }
        });
        // 人物风采
        getLists({type:7}).then((data) => {
            if (data.code !== 0) {
                this.$toast(data.msg)
            }else if(data.code === 0 && data.data.length){
                let forLength = 0;
                data.data.length<4 ? forLength = data.data.length :forLength=4
                for (let i = 0; i < forLength; i++) {
                    let temp = {};
                    temp.title = data.data[i].title;
                    temp.id = data.data[i].id;
                    temp.desc = data.data[i].content.replace(/<\/?[^>]*>/g,'').replace(/[\r\n|&nbsp;]/g,'').slice(0,70)+'...';
                    temp.imgSrc = JSON.parse(data.data[i].files)
                    temp.linkUrl = data.data[i].linkUrl
                    this.dataRwfc.push(temp)
                }
            }else{
                console.log('无数据');
            }
        });
    },
}
</script>

